import { useContext, useEffect } from 'react'
import { GlobalContext } from '../context/Provider'

interface CategoryRef {
    _id?: string
    name?: string
}

export const useEditCategorySelection = (
    category_id?: CategoryRef,
    subcategory_id?: CategoryRef,
    sub_subcategory_id?: CategoryRef
) => {
    const { setCategoryId, setSubCategoryId, setSubSubcategoryId } = useContext(GlobalContext)

    useEffect(() => {
        if (category_id?._id) {
            setCategoryId(category_id._id)
        }
        if (subcategory_id?._id) {
            setSubCategoryId(subcategory_id._id)
        }
        if (sub_subcategory_id?._id) {
            setSubSubcategoryId(sub_subcategory_id._id)
        }
    }, [category_id?._id, subcategory_id?._id, sub_subcategory_id?._id])
}
